import { styling } from '../core/styling.js';

const pointer = styling({
    $pointer: {
        type: 'boolean',
        properties: {
            cursor: 'pointer',
        },
    },
});

export { pointer };
//# sourceMappingURL=pointer.js.map
